import React from "react";
import { Box, Paper, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

export default function DataWorkspaceComingSoon() {
  const { t } = useTranslation("sidebar");
  return <Box sx={{ p: { xs: 2, md: 4 } }}>
    <Typography variant="h4" sx={{ mb: 3 }}>{t("dataWorkspace", { defaultValue: "Veri Çalışma Alanı" })}</Typography>
    <Paper sx={{ position: "relative", overflow: "hidden", minHeight: 340, borderRadius: 3 }}>
      <Box aria-hidden="true" sx={{ p: 4, filter: "blur(5px)", opacity: 0.35, pointerEvents: "none", userSelect: "none" }}>
        <Box sx={{ height: 36, width: "45%", bgcolor: "grey.300", mb: 4 }} />
        {Array.from({ length: 6 }, (_, row) => <Box key={row} sx={{ display: "flex", gap: 2, mb: 2 }}>
          {Array.from({ length: 5 }, (_, col) => <Box key={col} sx={{ height: 25, flex: 1, bgcolor: "grey.300" }} />)}
        </Box>)}
      </Box>
      <Box sx={{ position: "absolute", inset: 0, display: "grid", placeItems: "center" }}>
        <Typography variant="h4" sx={{ fontWeight: 700 }}>{t("comingSoon", { defaultValue: "Yakında" })}</Typography>
      </Box>
    </Paper>
  </Box>;
}
